import Vue from 'vue';

const $hnxEvents = new Vue();

export default $hnxEvents;
